// @flow

import moment from 'moment';

import type { Shift } from '../../common/typings';
import { formatDate, toDateShort, formatTime } from '../../utils/Utils';

export default function getNextShiftDescription(shift?: Shift, usTimeFormat: boolean): string {
  if (!shift) {
    return '';
  }

  let when;
  let addToPrefix = false;
  if (formatDate(shift.dtstart) === formatDate(new Date())) {
    when = 'Today';
  } else if (
    formatDate(shift.dtstart) ===
    formatDate(
      moment()
        .add(1, 'day')
        .toDate()
    )
  ) {
    when = 'Tomorrow';
  } else {
    addToPrefix = true;
    when = `${toDateShort(shift.dtstart, usTimeFormat)}`;
  }

  let prefix = '';

  if (shift.clockInStatus.clockedIn) {
    prefix = 'Your shift is in progress';
  } else if (shift.openEnd) {
    prefix = `Your next shift starts`;
  } else {
    prefix = `Your next shift is`;
  }

  prefix += addToPrefix ? ' on' : '';

  const fromText = formatTime(shift.dtstart, usTimeFormat);
  let suffix = fromText;

  if (!shift.openEnd) {
    const toText = formatTime(shift.dtend, usTimeFormat);
    suffix = `${fromText} to ${toText}`;
  }

  // \xa0 is &nbsp;
  return `${prefix} ${when}\xa0\xa0•\xa0\xa0${suffix}`;
}
